/**
 * useMetaStatus Hook
 * Checks if Meta Pixel is connected for the current store
 */

import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuthToken } from './useAuthToken';

const useMetaStatus = () => {
  const [status, setStatus] = useState('loading'); // 'loading' | 'connected' | 'disconnected' | 'error'
  const [metaInfo, setMetaInfo] = useState(null);
  const [error, setError] = useState(null);
  const { token } = useAuthToken();

  const fetchStatus = async () => {
    if (!token) return;

    const businessId = localStorage.getItem('user_id');
    if (!businessId) {
      setStatus('error');
      setError('Business ID not found');
      return;
    }

    try {
      setStatus('loading');
      const response = await axios.get(
        `${process.env.REACT_APP_APIURL}meta/status`,
        {
          params: { business_id: businessId },
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      if (response.data.success) {
        const data = response.data.data;
        setMetaInfo(data);
        setStatus(data.connected ? 'connected' : 'disconnected');
        setError(null);
      } else {
        setStatus('error');
        setError('Failed to fetch Meta Pixel status');
      }
    } catch (err) {
      console.error('[Meta] Status fetch error:', err);
      setStatus('error');
      setError(err.response?.data?.message || 'Failed to check Meta Pixel status');
    }
  };

  useEffect(() => {
    if (token) {
      fetchStatus();
    }
  }, [token]);

  return {
    status,
    metaInfo,
    error,
    refetch: fetchStatus
  };
};

export default useMetaStatus;
